export const IDEALIST_FOR_BUSINESS_ON_KEY = 'idealist-for-business-on';
